import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { FlagIcon } from "react-flag-kit";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };
  useEffect(() => {
    const path = location.pathname;
    if (path.endsWith("/de") && i18n.language !== "de") {
      i18n.changeLanguage("de");
    } else if (!path.endsWith("/de") && i18n.language !== "us") {
      i18n.changeLanguage("us");
    }
  }, [location.pathname, i18n]);

  useEffect(() => {
    const path = location.pathname;
    if (i18n.language === "de" && !path.endsWith("/de")) {
      const newPath = path.endsWith("/") ? `${path}de` : `${path}/de`;
      navigate(newPath);
    } else if (i18n.language === "us" && path.endsWith("/de")) {
      navigate(path.replace("/de", ""));
    }
  }, [i18n.language, location.pathname, navigate]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="fixed top-9 md:top-4 right-4 z-50">
      <div className="relative" ref={dropdownRef}>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center gap-[5px] px-3 py-2 rounded-full text-sm font-medium shadow bg-neutral-100 text-primary-700"
        >
          <FlagIcon
            code={i18n.language === "de" ? "DE" : "US"}
            style={{ width: 20, height: 15 }}
          />
          {isOpen ? (
            <FaChevronUp className="ml-2 text-primary-700" />
          ) : (
            <FaChevronDown className="ml-2 text-primary-700" />
          )}
        </button>

        {isOpen && (
          <div className="absolute right-0 mt-2 rounded-lg shadow-lg bg-neutral-100 border border-neutral-300">
            <button
              onClick={() => changeLanguage("us")}
              className="flex items-center gap-[5px] px-3 py-2 text-sm font-medium w-full text-primary-700 hover:bg-gray-200"
            >
              <FlagIcon code="US" style={{ width: 20, height: 15 }} />
              US
            </button>
            <button
              onClick={() => changeLanguage("de")}
              className="flex items-center gap-[5px] px-3 py-2 text-sm font-medium w-full text-primary-700 hover:bg-gray-200"
            >
              <FlagIcon code="DE" style={{ width: 20, height: 15 }} />
              DE
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
